import React, { PropsWithChildren } from "react";
import {Heading, suomifiDesignTokens as tokens} from "suomifi-ui-components";
import {MainWithBorder} from "./CommonStyles";

const Layout: React.FC<PropsWithChildren<Props>> = (props) => {
  return (
      <div>
        <Heading variant="h1" style={{margin: `${tokens.spacing.l} 0 ${tokens.spacing.s}`}}>
          {props.title}
        </Heading>
        <MainWithBorder>
          {props.children}
        </MainWithBorder>
      </div>
  );
};

interface Props {
  title: string
}

export default Layout;
